import './src/styles/_base.scss';

const isPreview = process.env.GATSBY_CONTENTFUL_PREVIEW === 'true';

function loadGTM(event) {
  initGTM();
  event.currentTarget.removeEventListener(event.type, loadGTM);
}

function initGTM() {
  // @ts-ignore
  if (window.isGTMLoaded) {
    return false;
  }
  // @ts-ignore
  window.isGTMLoaded = true;

  // @ts-ignore
  window.gtag('consent', 'update', {
    ad_user_data:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    ad_personalization:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    ad_storage:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    analytics_storage: 'granted',
  });

  // @ts-ignore
  window.dataLayer.push({
    event: 'consent_update_marketing',
    ID: new Date().getTime(),
    ad_user_data:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    ad_personalization:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    ad_storage:
      document?.cookie?.indexOf('marketingCookies') > -1 ? 'granted' : 'denied',
    analytics_storage: 'granted',
  });
}

export const onClientEntry = () => {
  async function refreshData() {
    await fetch(`/__refresh`, { method: 'POST' });
  }
  isPreview && refreshData();
  const cookieConsent = document.cookie.indexOf('cookieConsent') > -1;

  // if cookie banner should be shown, display it
  if (!cookieConsent) {
    document.documentElement.style.setProperty(
      '--cookieBannerDisplay',
      'block'
    );
  }

  !isPreview && initCookieBanner();
};

const initCookieBanner = () => {
  const statisticalCookiesApproved =
    document.cookie.indexOf('statisticalCookies') > -1;

  if (statisticalCookiesApproved) {
    document.onreadystatechange = () => {
      if (document.readyState !== 'loading') {
        setTimeout(initGTM, 3500);
      }
    };
    document.addEventListener('scroll', loadGTM);
    document.addEventListener('mousemove', loadGTM);
    document.addEventListener('touchstart', loadGTM);
  } else {
    document.addEventListener('statisticalCookies', loadGTM);
  }
};
